export default {
  NAME: 'name',
  DATE: 'date'
};